"use strict";


window.PXUTheme.contentCreator.accordion = {
  init: function () {
    const $accordionHeading = $('.accordion > dt > a, [data-cc-accordion] > dt > a');
    $('.accordion > dd, [data-cc-accordion] > dd').attr('aria-hidden', true);
    $accordionHeading.attr('aria-expanded', false);
    $accordionHeading.on('click', function () {
      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $accordionHeading.on('keydown', function (event) {
      let keyCode = event.keyCode || e.which;

      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload: function () {
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('click activate');
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('keydown');
  }
};
window.PXUTheme.contentCreator.slideshow = {
  init: function () {
    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
      pageDots: true,
      lazyLoad: 2
    });
  }
};
window.PXUTheme.animation = {
  init: function () {
    $('[data-scroll-class]').waypoint(function () {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, {
      offset: '70%'
    });
  },
  slideTransition: function ($el, animationName, callback) {
    $el.parents('.flickity-enabled').find('.animated').removeClass('animated ' + animationName);
    $el.addClass('animated').addClass(animationName);
  },
  unload: function ($target) {
    $target.data('scroll-class', '');
  }
};
const deferred = {};
window.PXUTheme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: (url, view, options = {}) => {
    let data;

    if (url in deferred) {
      return deferred[url];
    }

    const $deferred = $.Deferred();
    deferred[url] = $deferred;

    if (options.hash) {
      data = sessionStorage.getItem(url);

      if (data) {
        const deserialized = JSON.parse(data);

        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    } // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
    
    $.ajax({
      url,
      cache: false,
      data: `view=${view}`,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: response => {
        const el = document.createElement('div');
        el.innerHTML = response;
        
        const responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
        const htmls = el.querySelectorAll('[data-html]');
        let html = {};

        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }

        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html
            }));
          } catch (error) {
            console.error(error);
          }
        }

        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html
        });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    
    return $deferred.promise();
  }
};

window.PXUTheme.addImageDimension = function (imageUrl, size) {
  var insertPosition = imageUrl.lastIndexOf(".");
  return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
};

window.PXUTheme.breadcrumbs = {
  init: function (pages) {
    // Show pagination if number of pages is greater than 1
    if (pages > 1) {
      const breadcrumbSpan = document.querySelector('[data-breadcrumb-text]');
      const currentPage = document.querySelector('.paginate').dataset.currentPage ? document.querySelector('.paginate').dataset.currentPage : 1;
      const totalPages = document.querySelector('.paginate').dataset.paginatePages;
      document.querySelector('.js-breadcrumb-text').classList.remove('is-hidden');
      breadcrumbSpan.innerHTML = `${window.PXUTheme.translation.page_text} ${currentPage} ${window.PXUTheme.translation.of_text} ${totalPages}`;
    }
  },
  unload: function ($target) {
    document.querySelector('.js-breadcrumb-text').classList.add('is-hidden');
  }
};
window.PXUTheme.disclosure = {
  enable: function () {
    const $disclosure = $('[data-disclosure]');
    const $toggle = $('[data-disclosure-toggle]');
    const $disclosureWrap = $('.disclosure__list-wrap');
    const $mobileMenuDisclosureList = $('[data-disclosure-list]'); // Check if current opened menu is offscreen

    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }

      $disclosureWrap.removeClass('disclosure--left');
    } // Close menus on ESC


    $('body').on('keyup', function (e) {
      if (e.which == '27') {
        closeDisclosures();
      }
    }); // Close menus on hoverout

    $disclosure.on('mouseleave', function (e) {
      closeDisclosures();
    }); // Close menus on hoverout

    $disclosure.find('.disclosure-list__item:last-child').on('focusout', function (e) {
      closeDisclosures();
    }); // On click/focus event for toggling options

    $toggle.on('mouseenter focus', function (e) {
      // Close all other menus
      closeDisclosures(true, this);
      const $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    }); // Mobile toggle logic

    $mobileMenuDisclosureList.on('touchstart', function (e) {
      const $target = $(e.currentTarget);
      $target.parents('.disclosure').addClass('is-clicked');
      closeDisclosures(true, this);

      if ($target.hasClass('is-clicked') == false) {
        $target.attr('aria-expanded', 'true').addClass('is-clicked');
        checkOffScreen($target);
      } else {
        $target.attr('aria-expanded', 'false').removeClass('is-clicked');
        $disclosureWrap.removeClass('disclosure--left');
      }
    });
    $mobileMenuDisclosureList.on('focusout', function (e) {
      closeDisclosures(true, this);
    }); // Mobile form submitting

    $mobileMenuDisclosureList.on('change', function (e) {
      if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const $target = $(e.currentTarget);
        const selectedValue = e.currentTarget.value;
        const disclosureInput = $target.parents('.selectors-form__item').find('[data-disclosure-input]');
        const selectorForm = $target.parents('.selectors-form');

        if (!$target.hasClass('custom-currency')) {
          disclosureInput.val(selectedValue);
          selectorForm.submit();
        } else {
          $target.trigger('click');
        }
      }
    });
  },
  unload: function () {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
};

window.PXUTheme.mobileSidemenuCurrencySelector = {
  init: function($form) {
    var $this = this;
    this.element = $form;
    this.mainInput = this.element.querySelector("input[name='currency_code']");
    this.popup = this.element.querySelector("[data-currency-popup-container]");

    this.delegateElement = new domDelegate.Delegate($form);
    this.delegateElement.on('click', '[data-currency-popup-trigger]', $this.open.bind($this));
    this.delegateElement.on('change', 'input[name="currency"]', $this.currencySelected.bind($this));
  },
  open: function(event,target) {
    this.fancybox = $.fancybox.open(this.popup, {
      baseClass: 'currency__lightbox mobile',
      animationEffect: false,
      transitionEffect: false,
      animationDuration: 50,
      transitionDuration: 40,
      parentEl: this.element,
      hash: false,
      infobar : false,
      toolbar: false,
      touch: false,
      mobile: {
        preventCaptionOverlap: false,
        toolbar: false,
      },
      onActivate: (instance) => {
        $('html').addClass("no-scroll");
        var containerTop = this.element.getBoundingClientRect().top;
        var containerRight = this.element.getBoundingClientRect().right;
        this.popup.style.top = containerTop + "px";
        this.popup.style.left = containerRight + "px";
      },
      afterClose: (instance) => {
        $('html').removeClass("no-scroll");
      }
    });
  },
  currencySelected: function(event,target) {
    var inputs = this.popup.querySelectorAll("input[checked]");
    inputs.forEach(input => {
      input.removeAttribute("checked");
    });
    target.setAttribute("checked", true);
    this.mainInput.value = target.value;
    this.element.submit();
  }
};

window.PXUTheme.localizationSelector = {
  // Flag to track if user made a selection in the current popup session
  userMadeSelection: false,
  
  init: function($form) {
    let $this = this;
    this.element = document.querySelector("#LocalizationForm");
    
    // Safety timeout - always reveal page after 3 seconds max
    setTimeout(function() {
      $this.revealPage();
    }, 3000);
    
    if (!this.element) {
      // No form found - just reveal the page
      this.revealPage();
      return;
    }
    this.mainInput = this.element.querySelector("input[name='currency_code']");
    this.popup = this.element.querySelector("[data-currency-popup-container]");

    this.delegateElement = new domDelegate.Delegate(this.element);
    this.documentDelegate = new domDelegate.Delegate(document.documentElement);

    this.documentDelegate.on('click', '[data-localization-popup-trigger]', $this.open.bind($this));

    this.delegateElement.on('click', 'input.selected[name="currency"]', $this.labelClicked.bind($this));

    this.delegateElement.on('change', 'input:not(.selected)[name="currency"]', $this.currencySelected.bind($this));
    if (!Shopify.designMode) {
      this.checkLocalization();
    } else {
      // In design mode, just reveal the page
      this.revealPage();
    }
  },
  
  // Get current page's currency from the form
  getCurrentCurrency: function() {
    return this.mainInput ? this.mainInput.value : null;
  },
  
  // Map country handle to currency code
  getCurrencyForCountry: function(countryHandle) {
    const countryToCurrency = {
      "US": "USD",
      "CA": "CAD",
      "GB": "GBP"
    };
    
    // Check if it's an EU country (country codes only)
    const listEUCountryCodes = [
      "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", 
      "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", 
      "SI", "ES", "SE", "GF", "GP", "MQ", "ME", "YT", "RE", "MF", "GI", "AX",
      "PM", "GL", "BL", "SX", "AW", "CW", "WF", "PF", "NC", "TF", "AD", "LI",
      "MC", "SM", "VA", "JE", "GG"
    ];
    
    if (listEUCountryCodes.includes(countryHandle)) {
      return "EUR";
    }
    
    return countryToCurrency[countryHandle] || null;
  },
  
  // Redirect to a specific currency
  redirectToCurrency: function(currency) {
    if (!currency) return;
    
    const currentCurrency = this.getCurrentCurrency();
    if (currentCurrency === currency) return;
    
    // Find the radio input for the currency
    const currencyInput = this.popup.querySelector(`input[value="${currency}"]`);
    if (!currencyInput) return;
    
    // Set the currency and submit the form to redirect
    this.mainInput.value = currency;
    setTimeout(() => {
      this.element.submit();
    }, 100);
  },
  
  open: function(event, target) {
    let $this = this;
    // Reset the selection flag when opening popup
    this.userMadeSelection = false;
    
    this.fancybox = $.fancybox.open(this.popup, {
      baseClass: 'currency__lightbox',
      parentEl: this.element,
      toolbar: false,
      touch: false,
      mobile: {
        preventCaptionOverlap: false
      },
      buttons: [
        "close"
      ],
      onActivate: (instance) => {
        $('html').addClass("no-scroll");
      },
      afterClose: (instance) => {
        $('html').removeClass("no-scroll");
        
        // If modal was closed without selection, redirect to user's preferred currency
        if (!$this.userMadeSelection) {
          const preferredCurrency = getCookies("UserPreferredCurrency");
          if (preferredCurrency) {
            $this.redirectToCurrency(preferredCurrency);
          }
        }
      }
    });
  },
  
  currencySelected: function(event, target) {
    // Mark that user made a selection
    this.userMadeSelection = true;
    
    var inputs = this.popup.querySelectorAll("input[checked]");
    inputs.forEach(input => {
      input.removeAttribute("checked");
    });
    target.setAttribute("checked", true);
    this.mainInput.value = target.value;
    
    // Store user's preference - this is the key cookie that persists their choice
    setCookies("UserPreferredCurrency", target.value, 30);
    
    let $this = this;
    setTimeout(function() {
      $this.element.submit();
    }, 110);
  },
  
  labelClicked: function(event, target) {
    this.fancybox.close();
  },
  
  // Remove the hiding class to reveal the page
  revealPage: function() {
    document.documentElement.classList.remove('localization-redirecting');
  },
  
  // Main localization check - runs on every page load
  checkLocalization: function() {
    const $this = this;
    const currentCurrency = this.getCurrentCurrency();
    const preferredCurrency = getCookies("UserPreferredCurrency");
    
    // CASE 1: User already has a preferred currency stored
    if (preferredCurrency) {
      // If current page doesn't match preference, redirect immediately (no popup)
      if (currentCurrency !== preferredCurrency) {
        this.redirectToCurrency(preferredCurrency);
        // Don't reveal - we're redirecting
        return;
      }
      // If it matches, reveal page - user is on correct market
      this.revealPage();
      return;
    }
    
    // CASE 2: No preference stored yet - need to detect by IP
    this.detectLocationByIP();
  },
  
  // Detect user location by IP and handle accordingly
  detectLocationByIP: function() {
    const $this = this;
    const currentCurrency = this.getCurrentCurrency();
    
    // Get the current locale from the form
    let selectedLocale = this.element.getAttribute("data-active-country");
    let currentCountryCode;
    switch(selectedLocale) {
      case "CA":
        currentCountryCode = "CA";
        break;
      case "DE":
        currentCountryCode = "Europe";
        break;
      case "GB":
        currentCountryCode = "GB";
        break;
      case "US":
        currentCountryCode = "US";
        break;
      default:
        currentCountryCode = null;
    }
    
    const listEUCountryCodes = [
      "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", 
      "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", 
      "SI", "ES", "SE", "GF", "GP", "MQ", "ME", "YT", "RE", "MF", "GI", "AX",
      "PM", "GL", "BL", "SX", "AW", "CW", "WF", "PF", "NC", "TF", "AD", "LI",
      "MC", "SM", "VA", "JE", "GG"
    ];
    
    fetch("/browsing_context_suggestions.json?currency[enabled]=true")
      .then(response => response.json())
      .then(data => {
        let detectedCountry = data.detected_values.country.handle;
        
        // Get the currency code for the detected country
        const detectedCurrency = $this.getCurrencyForCountry(detectedCountry);
        
        if (!detectedCurrency) {
          // Unknown country - set current as preference and reveal page
          setCookies("UserPreferredCurrency", currentCurrency, 30);
          $this.revealPage();
          return;
        }
        
        // Store the detected currency as user's preference immediately
        // This ensures even if they close the popup, they get redirected to detected location
        setCookies("UserPreferredCurrency", detectedCurrency, 30);
        
        // Check if detected location matches current page
        const isMatch = (currentCountryCode === detectedCountry) || 
                        (currentCountryCode === "Europe" && listEUCountryCodes.includes(detectedCountry)) ||
                        (currentCurrency === detectedCurrency);
        
        if (isMatch) {
          // User is already on correct market - reveal page
          $this.revealPage();
          return;
        }
        
        // Location mismatch - reveal page and show popup to let user confirm or change
        $this.revealPage();
        $this.open();
      })
      .catch(error => {
        // On error, set current currency as preference and reveal page
        setCookies("UserPreferredCurrency", currentCurrency, 30);
        $this.revealPage();
      });
  }
};

window.PXUTheme.hideContent = {
  init() {
    fetch("/browsing_context_suggestions.json?currency[enabled]=true")
      .then(response => response.json())
      .then(data => {
        document.body.setAttribute("data-fetched-country", data.detected_values.country_name);
        document.body.setAttribute("data-selected-region", Shopify.country);
        this.removeSubscriptionBlock(data);
        this.handleSingleBrushHeads(data);
        this.hideClearPayBlock(data);
        this.handleLocalizedText(data);
        // this.removeGiftNote(data);
      });
  },
  removeSubscriptionBlock(data) {
    let fetchedCountry = data.detected_values.country_name;
    let block1 = document.querySelector("#PurchaseTypeBlock");
    let block2 = document.querySelector(".product-block--linked-product");
    let block3 = document.querySelector("[id^=placement-]");
    let block4 = document.querySelector(".purchase-details--price_container--subscription_wrapper");

    // remove subscription block on brush pdp unless UK
    // to add US -   
    let urlParams = new URLSearchParams(document.location.search);

    if (fetchedCountry != "United Kingdom" && fetchedCountry != "United States") {
      if (block1) {
        block1.remove();
      }
      if (block2) {
        block2.remove();
      }
      if (block4) {
        block4.remove();
      }
    } else {
      if (block2) {
        let container = block2.querySelector(".LinkedProductBlock")
        container.classList.add("Reveal");
      }
      // if (block3) {
      //   block3.style.display = "none";
      // }
    }
  },
  removeGiftNote(data) {
    setTimeout(function () {
      let fetchedCountry = data.detected_values.country_name;
      let freeShip = document.querySelector(".ajax-cart__cart-shipping-calculator-label");
      let giftNote = document.querySelectorAll(".gift_note .cart__note");
      if (fetchedCountry === "United States") {
        freeShip.remove();
        giftNote.forEach(function(el, index) {
          el.remove();
        });
      }
    }, 1000);
  },
  handleSingleBrushHeads(data) {
    let fetchedCountry = data.detected_values.country_name;
    let text = document.querySelector(".SubpriceText");
    if (fetchedCountry != "United Kingdom" && fetchedCountry != "United States") {
      let block = document.querySelector("#PurchaseTypeBlockSingle");
      if (block) {
        block.remove();
      }
      if (document.body.classList.contains('product-brush-head-x1')) {
        let form = document.querySelector(".product-block--form");
        // let quantityInput = form.querySelector("input[name='quantity']");
        // quantityInput.setAttribute('min', 1);
        // quantityInput.value = 1;
        // $(quantityInput).trigger('change');

        let link = document.querySelector(".LinkToSection");
        if (link) {
          link.remove()
        }

        let section = document.querySelector(".Section__2.target_section_1");
        if (section) {
          section.remove();
        }
      }

      // Hide Links of the prodcut
      let links = document.querySelectorAll("a");
      let prHandle = "heads-subscription-plan";
      for (let link of links) {
        let href = link.getAttribute("href");
        if (href && href.match(prHandle)) {
          link.style.display = "none";
        }
      }

      // Redirect to another product
      let url = window.location.pathname;
      if (url.match(prHandle)) {
        window.location.href = "/products/suri-sustainable-sonic-replacement-heads-x-3";
      }
    } else {
      if (text) {
        text.style.display = "block";
      }
    }
  },
  hideClearPayBlock(data) {
  },
  handleLocalizedText(data) {
    let fetchedCountry = data.detected_values.country.handle;
    Array.from(document.querySelectorAll("[data-content]")).map(item=>{
      if (item.dataset.content === fetchedCountry) {
        item.classList.add("Active")
        item.previousElementSibling.classList.add("Inactive");
      }
    });
  }
};

window.PXUTheme.customModal = {
  init(modal) {
    this.container = modal;
    this.delegateElement = new domDelegate.Delegate(this.container);
    this.documentDelegate = new domDelegate.Delegate(document.documentElement);
    this.documentDelegate.on("click", "[data-modal-trigger]", this.open.bind(this));
    this.delegateElement.on("click", "[data-modal='close']", this.close.bind(this));
  },

  open(event, target) {
    let modalID = target.getAttribute("data-modal-trigger");
    if (this.container.getAttribute("data-custom-modal") === modalID){
      this.container.classList.add("Active");
      $("html").addClass("no-scroll");
      let images = this.container .querySelectorAll(".lazyload");
      images.forEach((image)=>{
        lazySizes.loader.unveil(image);
      });
      return;
    }
    
  },

  close(event, target) {
    event.preventDefault();
    this.container.classList.remove("Active");
    $("html").removeClass("no-scroll");
  }

}

function getCookies(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length,c.length);
      }
  }
  return null;
};
function setCookies(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
};
function eraseCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
// window.PXUTheme.geolocation = {
//   init: function() {
//     return;
//     this.geoForm = document.querySelector("#geolocation_form");
//     if (!this.geoForm) return;
//     if (!this.getCookies("geolocationPerformed")) {
//       this.fetchData();
//     }
//   },
//   getCookies: function(name) {
//     var nameEQ = name + "=";
//     var ca = document.cookie.split(';');
//     for(var i=0;i < ca.length;i++) {
//         var c = ca[i];
//         while (c.charAt(0)==' ') c = c.substring(1,c.length);
//         if (c.indexOf(nameEQ) == 0) {
//           return c.substring(nameEQ.length,c.length);
//         }
//     }
//     return null;
//   },
//   fetchData: function() {
//     fetch("/browsing_context_suggestions.json?currency[enabled]=true")
//       .then(response => response.json())
//       .then(data => {
//         console.log(data)
//         if (data.suggestions.length > 0) {
//           let suggestedCurrency = data.suggestions[0].parts.currency.handle;
//           console.log(suggestedCurrency)
//           let currencyOptions = this.geoForm.querySelectorAll("[name='geolocation_currency']");
//           let mainOptions = document.querySelectorAll("form[action='/localization'] input[name='currency_code']");
//           mainOptions.forEach(option => {
//             option.value = suggestedCurrency;
//           });
//           this.setCookies("geolocationPerformed", true, 14);
//           this.setCookies("selectedCurrency", suggestedCurrency, 14);
//           this.geoForm.submit();
//         }
//       })
//   },
//   setCookies: function(name,value,days) {
//     var expires = "";
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days*24*60*60*1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "")  + expires + "; path=/";
//   },
//   eraseCookie: function(name) {
//     document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
//   }
// }

window.PXUTheme.dropdownMenu = function () {
  // Grab menu items
  const menuItems = $('.navbar-link'); // Grab dropdowns

  const dropdowns = $('.navbar-dropdown'); // Grab megamenus

  const megamenus = $('.has-mega-menu'); // Listen for enter key

  menuItems.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        } // Show dropdown


        $(this).closest('.navbar-item').addClass('show-dropdown'); // Reset itemVisited so that they can visit the link

        itemVisited = true;
      }
    });
    $(item).closest('.navbar-item').on('focusout', function (e) {
      if ($(this).find(e.relatedTarget).length === 0) {
        $(item).closest('.navbar-item').removeClass('show-dropdown');
      }
    });
  }); // Listen for enter key

  dropdowns.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        if ($(this).find('.has-submenu').length > 0) {
          $(this).addClass('show-nested-dropdown');
        } // Reset itemVisited so that they can visit the link


        itemVisited = true;
      }
    });
  }); // Listen for enter key

  megamenus.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        } // Show megamenu


        $(this).find('.mega-menu').addClass('mega-menu--show'); // Reset itemVisited so that they can visit the link

        itemVisited = true;
      }
    }); // Hide mega menu on focusout

    $(item).on('focusout', function (e) {
      if ($(item).find(e.relatedTarget).length === 0) {
        $(item).find('.mega-menu').removeClass('mega-menu--show');
      }
    });
  });
};

window.PXUTheme.newsletterAjaxForm = {
  init: function () {
    // Selectors
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    $ajaxForm.each(function () {
      const $form = $(this);
      $form.on('submit', function (e) {
        if ($('input[name="challenge"]', $form).val() !== "true") {
          $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (data) {
              $form.fadeOut("slow", () => {
                $form.prev('.form__success-message').html(window.PXUTheme.translation.newsletter_form_success);
              });
            },
            error: function (data) {
              $('input[name="challenge"]', $form).val('true');
              $form.submit();
            }
          });
          e.preventDefault();
        }
      });
    });
  },
  unload: function () {
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    const $submitButton = $ajaxForm.find(':submit');
    $submitButton.off();
  }
};

window.PXUTheme.getSectionData = function ($section) {
  const sectionId = $section.attr('id').replace('shopify-section-', '');
  var $dataEl = $section.find('[data-section-data][data-section-id=' + sectionId + ']').first();
  if (!$dataEl) return {}; // Load data from attribute, or innerHTML

  var data = $dataEl.data('section-data') || $dataEl.html();
  try {
    return JSON.parse(data);
  } catch (error) {
    console.warn(`Sections: invalid section data found. ${error.message}`);
    return {};
  }
};

window.PXUTheme.infiniteScroll = {
  init: function () {
    this.defaults = {
      grid: '[data-load-more--grid]',
      gridItems: '[data-load-more--grid-item]'
    };
    $('body').on('click', '[data-load-more]', function (e) {
      e.preventDefault();
      const $button = $(this);
      const url = $button.attr('href');
      window.PXUTheme.infiniteScroll.loadNextPage(url, $button);
    });
    $('body').on('click', '[data-load-more-infinite]', function (e) {
      window.PXUTheme.infiniteScroll.enableInfinite();
      $(this).remove(); // Prevent link from going to next page

      e.stopPropagation();
      return false;
    });

    if ($('[data-load-infinite-scroll]').length) {
      window.PXUTheme.infiniteScroll.enableInfinite();
    }
  },
  loadNextPage: function (url, $button) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      beforeSend: function () {
        $button.addClass('is-loading');
      },
      success: data => {
        $button.removeClass('is-loading');
        const thumbnails = $(data).find(this.defaults.gridItems);
        const loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $(this.defaults.grid).first().append(thumbnails); // Initialize product reviews

        window.PXUTheme.productReviews.init(); // When there are no additional pages, hide load more button

        if (typeof loadMoreButtonUrl == 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error: function (x, t, m) {
        location.replace(location.protocol + '//' + location.host + filterURL);
      }
    });
  },
  enableInfinite: function () {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(this.defaults.grid)[0],
      items: '[data-load-more--grid-item]',
      more: '[data-load-infinite]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function () {
        $('[data-load-infinite]').removeClass('is-hidden');
      },
      onAfterPageLoad: function (data) {
        // Initialize product reviews
        window.PXUTheme.productReviews.init();
      }
    });
  },
  unload: function () {
    $('[data-load-more]').off();
    $('[data-load-infinite]').off();
  }
};

window.PXUTheme.flickityIosFix = function () {
  var touchingCarousel = false,
      touchStartCoords;
  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  });
  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };
    if (Math.abs(moveVector.x) > 7) e.preventDefault();
  }, {
    passive: false
  });
};

window.PXUTheme.loadScript = function (name, url, callback) {
  if (window.PXUTheme.theme[name]) {
    callback;
  } else {
    $.ajax({
      url: url,
      dataType: 'script',
      success: callback,
      async: false
    });
  }
};

window.PXUTheme.applyMasonry = function (selector, gutterSize) {
  let $galleryWrapper = $('.gallery-type--masonry');

  if ($galleryWrapper.length > 0) {
    $galleryWrapper.imagesLoaded().progress(function () {
      $galleryWrapper.isotope({
        layoutMode: 'masonry',
        itemSelector: selector,
        percentPosition: true,
        masonry: {
          columnWidth: selector,
          gutter: gutterSize
        }
      });
    });
  }
};

window.PXUTheme.applyHorizontalMasonry = function () {
  let $galleryWrapper = $('.gallery-type--horizontal-masonry');
  $galleryWrapper.find('.gallery__item').each(function (e) {
    var wrapper = $(this);
    var imgWidth, imgHeight;
    setTimeout(function () {
      imgWidth = wrapper.find('img').width();
      imgHeight = wrapper.find('img').height();
      wrapper.css("flex-basis", imgWidth * 200 / imgHeight);
      wrapper.css("flex-grow", imgWidth * 200 / imgHeight);
      wrapper.find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    }, 100);
  });
};

// window.PXUTheme.mobileMenu = {
//   init: function () {
//     this.mainWrapper = document.querySelector("[data-enable_overlay]");
//     this.mainContainer = document.querySelector("#mobile-header");

//     this.wrapper = document.querySelector(".mobile-menu-wrapper");
//     this.element = document.querySelector(".mobile-menu-wrapper .mobile-menu");
//     this.$mobileMenuToggle = $('[data-show-mobile-menu]');
//     this.$mobileMenuIcon = $('.mobile-menu__toggle-icon');
//     this.$mobileDropDownToggle = $('.mobile-menu .close-dropdown');
//     $('body').on('click', '[data-show-mobile-menu="false"]', function () {
//       window.PXUTheme.mobileMenu.open();
//     });
//     $('body').on('click', '[data-show-mobile-menu="true"]', function () {
//       window.PXUTheme.mobileMenu.close();
//     });
//     this.overlayNeeded = window.PXUTheme.jsHeader.sectionUnderlayIsImage();

//     if (window.PXUTheme.jsHeader.enable_sticky === true) {

//       if (window.PXUTheme.jsHeader.sectionUnderlayIsImage()) {
//         this.enableOverlaySticky();
//       } else {
//         window.PXUTheme.jsHeader.updateOverlayStyle(this.overlayNeeded);
//         this.enableSticky();
//       }
//     }
//     this.element.style.top = "-" + this.element.offsetHeight + "px";

//   },
//   open: function () {
//     this.rememberState = this.mainWrapper.getAttribute("data-enable_overlay");
//     this.mainWrapper.setAttribute("data-enable_overlay", false);

//     clearTimeout(this.timeoutID);
//     this.wrapper.style.top = "100%";

//     //Get current position on page
//     let currentScrollPosition = window.scrollY;

//     $('body').attr('data-current-position', currentScrollPosition); // Calculate height of mobile content area

//     let announcementHeight = 0;
//     let mobileHeaderHeight = parseInt($('.mobile-header').height());

//     if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
//       announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
//     }

//     // let mainMobileContentHeight = parseInt($('.mobile-menu').outerHeight());
//     // $('.mobile-menu__overlay').css({
//     //   height: `calc(100vh - ${mobileHeaderHeight + announcementHeight + mainMobileContentHeight}px)`
//     // });

//     // $('.mobile-menu').css({
//     //   height: `calc(100vh - ${mobileHeaderHeight + announcementHeight}px)`
//     // });
//     // $('.mobile-menu__content').css({
//     //   marginBottom: `${mobileHeaderHeight + announcementHeight}px`
//     // });

//     this.$mobileMenuIcon.addClass('is-active');
//     $('[data-show-mobile-menu]').attr('data-show-mobile-menu', true);

//     if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
//       window.PXUTheme.jsAjaxCart.hideMiniCart();
//       window.PXUTheme.jsAjaxCart.hideDrawer();
//     } 
//     //Set delay on menu open to get proper page position
//     setTimeout(function () {
//       $('body').addClass('mobile-menu--opened');
//       $('html').addClass('no--scroll');
//     }, 10);
//   },
//   close: function () {
//     this.timeoutID = setTimeout(function(){
//       this.wrapper.style.top = "-10000px"; 
//     }.bind(this), 310);
//     this.element.style.top = "-" + this.element.offsetHeight + "px";
//     $('body').removeClass('mobile-menu--opened'); 
//     $('html').removeClass('no--scroll');
//     // Once mobile menu is closed, return back to previous position on page
//     let lastScrollPosition = $('body').attr('data-current-position');
//     window.scrollTo(0, lastScrollPosition);
//     this.$mobileMenuIcon.removeClass('is-active');
//     $('[data-show-mobile-menu]').attr('data-show-mobile-menu', false);
//     setTimeout(function(){
//       this.mainWrapper.setAttribute("data-enable_overlay", this.rememberState)
//     }.bind(this), 280)   
//   },
//   enableSticky: function () {
//     //window.PXUTheme.jsHeader.disableSticky();
//     let $stickyEl = $('#mobile-header');
//     let offset = 0;
//     if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
//       offset += window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
//     }

//     $stickyEl.addClass('sticky--enabled');
//     if ( $stickyEl) {
//       $stickyEl.sticky({
//         wrapperClassName: 'header-sticky-wrapper',
//         zIndex: 40,
//         topSpacing: offset
//       }).on('sticky-start', () => {
//         var headerheight = $('#mobile-header').height();
//         var annoucementHeight = $('.announcement-sticky-wrapper').height() || 0;
//         var totalHeight = headerheight + annoucementHeight;
//         $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');
//       }).on('sticky-end', () => {
//         $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%'); // Safety timeout for logo width transition which can throw calculated height off
  
//         setTimeout(() => {
//           $stickyEl.sticky('update');
//         }, 250);
//         $stickyEl.find('.sticky-menu-wrapper').removeClass('is-visible');
//       });
//     }
//   },
//   disableSticky: function () {
//     let $stickyEl = $('#mobile-header');
//     $stickyEl.unstick();
//     $stickyEl.removeClass('sticky--enabled');
//     // setTimeout(function () {
//     //   $('.header-sticky-wrapper').css('height', '0');
//     // }, 249);
//   },
//   unload: function ($section) {
//     $('[data-mobilemenu-toggle]').off();
//     $('.mobile-menu__toggle-icon').off();
//     $('.mobile-menu .close-dropdown').off();
//     this.disableSticky();
//   },
//   enableOverlaySticky: function() {
//     var offset = this.mainContainer.offsetHeight;
//     window.addEventListener("scroll", function(){
//       if (isScreenSizeLarge()) return;
//       if(window.scrollY >= offset) {
//         this.mainWrapper.setAttribute("data-enable_overlay", false)
//       } else {
//         // changed this to true to enable transparent header
//         this.mainWrapper.setAttribute("data-enable_overlay", false)
//       }
//     }.bind(this));
//   }
// };
window.PXUTheme.objectFitImages = {
  init: function () {
    objectFitImages();

    if (window.PXUTheme.theme_settings.image_loading_style == 'color') {
      this.calculateAspectRatio();
    }
  },
  calculateAspectRatio: function () {
    // Get list of image-element__wrap's to calculate
    const imageWrap = document.querySelectorAll('[data-calculate-aspect-ratio]'); // Iterate through list

    for (let i = 0; i < imageWrap.length; i++) {
      const image = imageWrap[i].firstElementChild; // Calculate aspect ratio based off of original width & height

      const aspectRatio = image.getAttribute('width') / image.getAttribute('height'); // Calculate proper width based off of aspect ratio

      const aspectWidth = image.height * aspectRatio; // Apply width to image wrap

      imageWrap[i].style.maxWidth = `${Math.floor(aspectWidth)}px`;
    } // Remove background color once loaded


    document.addEventListener('lazyloaded', function (e) {
      e.srcElement.parentNode.style.background = 'none';
    });
  },
  unload: function () {}
};
/* option_selection.js */

function floatToString(t, e) {
  var o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}

if ("undefined" == typeof Shopify) var Shopify = {};
Shopify.each = function (t, e) {
  for (var o = 0; o < t.length; o++) e(t[o], o);
}, Shopify.map = function (t, e) {
  for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));

  return o;
}, Shopify.arrayIncludes = function (t, e) {
  for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;

  return !1;
}, Shopify.uniq = function (t) {
  for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);

  return e;
}, Shopify.isDefined = function (t) {
  return "undefined" == typeof t ? !1 : !0;
}, Shopify.getClass = function (t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}, Shopify.extend = function (t, e) {
  function o() {}

  o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype;
}, Shopify.locationSearch = function () {
  return window.location.search;
}, Shopify.locationHash = function () {
  return window.location.hash;
}, Shopify.replaceState = function (t) {
  window.history.replaceState({}, document.title, t);
}, Shopify.urlParam = function (t) {
  var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
  return e && decodeURIComponent(e[1].replace(/\+/g, " "));
}, Shopify.newState = function (t, e) {
  var o;
  return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash();
}, Shopify.setParam = function (t, e) {
  Shopify.replaceState(Shopify.newState(t, e));
}, Shopify.Product = function (t) {
  Shopify.isDefined(t) && this.update(t);
}, Shopify.Product.prototype.update = function (t) {
  for (let property in t) this[property] = t[property];
}, Shopify.Product.prototype.optionNames = function () {
  return "Array" == Shopify.getClass(this.options) ? this.options : [];
}, Shopify.Product.prototype.optionValues = function (t) {
  if (!Shopify.isDefined(this.variants)) return null;
  var e = Shopify.map(this.variants, function (e) {
    var o = "option" + (t + 1);
    return void 0 == e[o] ? null : e[o];
  });
  return null == e[0] ? null : Shopify.uniq(e);
}, Shopify.Product.prototype.getVariant = function (t) {
  var e = null;
  return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) {
    for (var i = !0, r = 0; r < t.length; r++) {
      var n = "option" + (r + 1);
      o[n] != t[r] && (i = !1);
    }

    return 1 == i ? void (e = o) : void 0;
  }), e);
}, Shopify.Product.prototype.getVariantById = function (t) {
  for (var e = 0; e < this.variants.length; e++) {
    var o = this.variants[e];
    if (t == o.id) return o;
  }

  return null;
}, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function (t, e) {
  function o(t, e) {
    return "undefined" == typeof t ? e : t;
  }

  function i(t, e, i, r) {
    if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
    t = (t / 100).toFixed(e);
    var n = t.split("."),
        a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
        s = n[1] ? r + n[1] : "";
    return a + s;
  }

  "string" == typeof t && (t = t.replace(".", ""));
  var r = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      a = e || this.money_format;

  switch (a.match(n)[1]) {
    case "amount":
      r = i(t, 2);
      break;

    case "amount_no_decimals":
      r = i(t, 0);
      break;

    case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;

    case "amount_with_apostrophe_separator":
      r = i(t, 2);
      break;

    case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      r = i(t, 0, ".", " ");
  }

  return a.replace(n, r);
}, Shopify.OptionSelectors = function (t, e) {
  return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0;
}, Shopify.OptionSelectors.prototype.initDropdown = function () {
  var t = {
    initialLoad: !0
  },
      e = this.selectVariantFromDropdown(t);

  if (!e) {
    var o = this;
    setTimeout(function () {
      o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t);
    });
  }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) {
  this.selectors[0].element.onchange(t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) {
  var e = this.selectVariantFromParams(t);
  e || this.selectVariantFromDropdown(t);
}, Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
  var e = document.getElementById(t),
      o = e.parentNode;
  Shopify.each(this.buildSelectors(), function (t) {
    o.insertBefore(t, e);
  }), e.style.display = "none", this.variantIdField = e;
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
  var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
  if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
  var o = e.value;
  return this.selectVariant(o, t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
  var e = Shopify.urlParam("variant");
  return this.selectVariant(e, t);
}, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
  var o = this.product.getVariantById(t);
  if (null == o) return !1;

  for (var i = 0; i < this.selectors.length; i++) {
    var r = this.selectors[i].element,
        n = r.getAttribute("data-option"),
        a = o[n];
    null != a && this.optionExistInSelect(r, a) && (r.value = a);
  }

  return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0;
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
  for (var o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0;
}, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
  Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
  var o = document.getElementById(t);
  Shopify.each(this.buildSelectors(), function (t) {
    o.appendChild(t);
  });
}, Shopify.OptionSelectors.prototype.buildSelectors = function () {
  for (var t = 0; t < this.product.optionNames().length; t++) {
    var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
    e.element.disabled = !1, this.selectors.push(e);
  }

  var o = this.selectorDivClass,
      i = this.product.optionNames(),
      r = Shopify.map(this.selectors, function (t) {
    var e = document.createElement("div");

    if (e.setAttribute("class", o), i.length > 1) {
      var r = document.createElement("label");
      r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r);
    }

    return e.appendChild(t.element), e;
  });
  return r;
}, Shopify.OptionSelectors.prototype.selectedValues = function () {
  for (var t = [], e = 0; e < this.selectors.length; e++) {
    var o = this.selectors[e].element.value;
    t.push(o);
  }

  return t;
}, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
  var o = this.selectedValues(),
      i = this.product.getVariant(o);
  i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e);
}, Shopify.OptionSelectorsFromDOM = function (t, e) {
  var o = e.optionNames || [],
      i = e.priceFieldExists || !0,
      r = e.delimiter || "/",
      n = this.createProductFromSelector(t, o, i, r);
  e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!Shopify.isDefined(o)) var o = !0;
  if (!Shopify.isDefined(i)) var i = "/";
  var r = document.getElementById(t),
      n = r.childNodes,
      a = (r.parentNode, e.length),
      s = [];
  Shopify.each(n, function (t, r) {
    if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
      var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
      0 == e.length && (a = n.length - (o ? 1 : 0));
      var p = n.slice(0, a),
          l = o ? n[a] : "",
          c = (t.getAttribute("value"), {
        available: t.disabled ? !1 : !0,
        id: parseFloat(t.value),
        price: l,
        option1: p[0],
        option2: p[1],
        option3: p[2]
      });
      s.push(c);
    }
  });
  var p = {
    variants: s
  };

  if (0 == e.length) {
    p.options = [];

    for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1);
  } else p.options = e;

  return p;
}, Shopify.SingleOptionSelector = function (t, e, o, i) {
  this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select");

  for (var r = 0; r < i.length; r++) {
    var n = document.createElement("option");
    n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n);
  }

  return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) {
    i = i || {}, t.updateSelectors(e, i);
  }, !0;
}, Shopify.Image = {
  preload: function (t, e) {
    for (var o = 0; o < t.length; o++) {
      var i = t[o];
      this.loadImage(this.getSizedImageUrl(i, e));
    }
  },
  loadImage: function (t) {
    new Image().src = t;
  },
  switchImage: function (t, e, o) {
    if (t && e) {
      var i = this.imageSize(e.src),
          r = this.getSizedImageUrl(t.src, i);
      o ? o(r, t, e) : e.src = r;
    }
  },
  imageSize: function (t) {
    var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
    return null != e ? e[1] : null;
  },
  getSizedImageUrl: function (t, e) {
    if (null == e) return t;
    if ("master" == e) return this.removeProtocol(t);
    var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (null != o) {
      var i = t.split(o[0]),
          r = o[0];
      return this.removeProtocol(i[0] + "_" + e + r);
    }

    return null;
  },
  removeProtocol: function (t) {
    return t.replace(/http(s)?:/, "");
  }
}, Shopify.OptionSelectors.HistoryState = function (t) {
  this.browserSupports() && this.register(t);
}, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
  window.addEventListener("popstate", function (e) {
    t.selectVariantFromParamsOrDropdown({
      popStateCall: !0
    });
  });
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) {
  this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id));
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
  return window.history && window.history.replaceState;
};
/*============================================================================
Product media controls
==============================================================================*/

window.PXUTheme.productMedia = {
  models: [],
  setupMedia: function () {
    const config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.PXUTheme.productMedia.models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      window.PXUTheme.productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};
window.PXUTheme.productReviews = {
  init: function () {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      });
    }
  },
  productReviewScroll: function () {
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        window.PXUTheme.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  unload: function () {
    $('.spr-badge-container').off();
  }
};
window.PXUTheme.quantityBox = {
  init: function () {
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
      document.documentElement.dispatchEvent(new CustomEvent('quantity:updated', {
        bubbles: true,
        detail: this
      }));
    });
    $('body').on('keyup keydown change', '.quantity-input', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
      document.documentElement.dispatchEvent(new CustomEvent('quantity:updated', {
        bubbles: true,
        detail: this
      }));
    });
  },
  updateQuantityControls: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    let valMin = parseInt($input.attr("min"));

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (val <= valMin) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
  },
  updateQuantity: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    const lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    let valMin = $input.attr('min') || 0;

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }

    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    } // Update quantity if within cart (vs on the product page)


    if ($el.parents('[data-line-item]').length) {
      const lineID = $quantityBox.data('line-item-key');
      window.PXUTheme.quantityBox.updateCart(lineID, val);
    } // Call to update quantity controls


    window.PXUTheme.quantityBox.updateQuantityControls($el);
  },
  updateCart: function (lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    $.ajax({
      type: 'POST',
      url: window.PXUTheme.routes.cart_change_url,
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let itemsLeftText = '';
        let quantityWarning = $(`[data-line-item="${lineID}"]`).find('.quantity-warning');
        let $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box');
        let $currentDiscount = $('.cart__form').data('currentDiscount'); //check to see if there are correct amount of products in array

        const cartItemsLineID = lineID - 1;

        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }

        for (let i = 0; i < cart.items.length; i++) {
          if (i != cartItemsLineID) {
            if (cart.items[i].id == cart.items[cartItemsLineID].id) {
              newQuantity += cart.items[i].quantity;
            }
          }
        }

        if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = window.PXUTheme.translation.product_count_one;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
              $('.quantity-minus', $quantityBox).attr('disabled', true);
            } else {
              itemsLeftText = window.PXUTheme.translation.product_count_other;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
            }
          }
        } //Update total discount value


        $('.cart__form').data('currentDiscount', cart.total_discount); // Apply quantity warning

        quantityWarning.addClass('animated bounceIn');

        // Update cart page totals (for /cart page)
        const moneyFormat = document.querySelector('body')?.dataset?.moneyFormat || '${{amount}}';
        
        // Update line item total for this specific item
        const $lineItem = $(`[data-line-item="${lineID}"]`);
        if ($lineItem.length && cart.items[cartItemsLineID]) {
          const linePrice = cart.items[cartItemsLineID].final_line_price;
          const $lineTotal = $lineItem.find('.cart__total .money');
          if ($lineTotal.length) {
            $lineTotal.html(Shopify.formatMoney(linePrice, moneyFormat));
          }
        }
        
        // Update cart subtotal
        const $subtotal = $('.cart__subtotal .money');
        if ($subtotal.length) {
          $subtotal.html(Shopify.formatMoney(cart.total_price, moneyFormat));
        }
        
        // Update total savings
        let totalSavings = cart.total_discount;
        // Add compare-at-price savings
        cart.items.forEach(item => {
          if (item.original_line_price > item.final_line_price) {
            totalSavings += (item.original_line_price - item.final_line_price);
          }
        });
        const $savingsEl = $('.cart__total-discount .money');
        if ($savingsEl.length && totalSavings > 0) {
          $savingsEl.html(Shopify.formatMoney(totalSavings, moneyFormat));
        }

        // Update slide-out cart
        if (window.PXUTheme && window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateCart();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  unload: function ($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};
window.PXUTheme.queryParameters = {};

if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');

    if (aKeyValue.length > 1) {
      window.PXUTheme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

window.PXUTheme.responsiveVideo = {
  init: function () {
    // Find youtube iframes
    var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]'); // For each iframe, if parent is a responsive video wrapper do nothing
    // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

    $videoIframes.each(function (index, iframe) {
      // Update selector
      var $iframe = $(iframe);

      if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
        $iframe.wrap('<div class="lazyframe" data-ratio="16:9"></div>');
      }
    });
  }
};

function selectCallback(productEl, product, variant, state, initial, queryParams = null ) {
  const $product = $(productEl);
  const $notifyForm = $('.product__notify-form', $product);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');
  const $productFormInput = $productForm.find('.quantity-input');
  const $notifyFormInputs = $('.notify_form__inputs');
  const notifyEmail = window.PXUTheme.translation.notify_form_email;
  const notifyEmailValue = window.PXUTheme.translation.contact_email;
  const notifySend = window.PXUTheme.translation.notify_form_send;
  const notifyUrl = $notifyFormInputs.data('url');
  let notifyMessage = '';
  let notifyEmailInput = '';

  if (variant) {
    if (variant.title != null) {
      // Escape variant titles
      const variantTitle = variant.title.replace(/"/g, '&quot;');
      notifyMessage = `${window.PXUTheme.translation.email_content}${variantTitle} | ${notifyUrl}?variant=${variant.id}`;
    }
  } else {
    notifyMessage = `${window.PXUTheme.translation.email_content} | ${notifyUrl}`;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${window.PXUTheme.translation.customer_email}" />`;
  } else {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }

  const notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field has-addons">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`; // Image Variant feature

  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.js-gallery-modal', $product);
    $sliders.each((_index, value) => {
      const $slider = $(value);
      const $sliderInstance = window.Flickity.data(value);
      const index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');
      if ($slider.is(':visible') && $sliderInstance !== undefined && !initial) {
        $sliderInstance.select(index, false, true);
      }
    });
  } // Emits custom event

  const $selectDropdown = $productForm.find('[data-variant-selector]');
  $selectDropdown.trigger('selectedVariantChanged');
  $('.cart-warning', $product).text('');

  if (variant) {
    $('.sku', $product).text(variant.sku);
    $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${variant.title}`);
  }

  const variantWithInventory = { ...variant,
    ...(variantInventory ? variantInventory.find(v => v.id === variant.id) || {} : {})
  };

  let localizationForm = document.querySelector('#LocalizationForm');
  let localizationFormActive = localizationForm.getAttribute('data-active-country');
  
  if (variant && variant.available) {
    let localizationForm = document.querySelector('#LocalizationForm');
    let localizationFormActive = localizationForm.getAttribute('data-active-country');
    // if ((variant.id == 41438727143612 && localizationFormActive == 'US') ) {
    //   const message = variant ? window.PXUTheme.translation.soldOut : window.PXUTheme.translation.unavailable;
    //   $('.items_left', $product).text('');
    //   $('[data-max-inventory-management]', $product).removeAttr('max');
    //   $('.sold_out', $product).text(message); // If we haven't selected all options, let the add to cart button be enabled
    //   if (state === 'not-selected') {
    //     $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', '').find('span.text').text($('[data-add-to-cart-trigger]', $product).data('label'));
    //   } else {
    //     $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', null).find('span.text').text(message);
    //     // custon floating button
    //     // $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('button--add-to-cart-label span:not(.text)').hide();
    //   }
  
    //   $('.shopify-payment-button', $product).hide();
    //   $('.purchase-details__quantity', $product).hide();
    //   $notifyForm.hide();
    //   $notifyFormInputs.empty();
  
    //   if (variant && !variant.available) {
    //     $notifyForm.fadeIn();
    //     $notifyFormInputs.empty();
    //     $notifyFormInputs.append(notifyFormHTML);
    //   }
    //   return;
    // }
      
    let addToCartButton = document.querySelector('.purchase-details__buttons .button--add-to-cart');
    let addToCartButtonText = document.querySelector('.purchase-details__buttons .button--add-to-cart .text');
    let soldOutButton;
    addToCartButton.disabled = false;
    
    if (variantWithInventory.inventory_management && variantWithInventory.inventory_quantity > 0) {
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        let itemsLeftText = window.PXUTheme.translation.product_count_other;

        if (variantWithInventory.inventory_quantity === 1) {
          itemsLeftText = window.PXUTheme.translation.product_count_one;
        }

        const inventoryThreshold = window.PXUTheme.theme_settings.inventory_threshold;

        if (variantWithInventory.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variantWithInventory.inventory_quantity} ${itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }

      if (variantWithInventory.inventory_policy === 'deny') {
        $('[data-max-inventory-management]', $product).attr('max', variantWithInventory.inventory_quantity); // Check to see if quantity selector should be disabled based on inventory remaining

        window.PXUTheme.quantityBox.updateQuantityControls($productFormInput);
      }
    } else {
      $('.items_left', $product).text('');
      $('[data-max-inventory-management]', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('span.text').text(function(){return $(this).closest('[data-add-to-cart-trigger]').data('label');}); // Initialize shopify payment buttons

    // custon floating button
    $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('button--add-to-cart-label span:not(.text)').show();

    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    $('.shopify-payment-button', $product).show();
    if (
      !document.body.classList.contains("new-styles")) {
      $('.purchase-details__quantity', $product).show();
    }

    $notifyForm.hide();
    $notifyFormInputs.empty();
    $notifyFormInputs.append(notifyFormHTML);

    if (window.PXUTheme.currencyConverter) {
      window.PXUTheme.currencyConverter.convertCurrencies();
    }

  } else {
    const message = variant ? window.PXUTheme.translation.soldOut : window.PXUTheme.translation.unavailable;
    $('.items_left', $product).text('');
    $('[data-max-inventory-management]', $product).removeAttr('max');
    $('.sold_out', $product).text(message); // If we haven't selected all options, let the add to cart button be enabled
    if (state === 'not-selected') {
      $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', '').find('span.text').text($('[data-add-to-cart-trigger]', $product).data('label'));
    } else {
      $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', null).find('span.text').text(message);
      // custon floating button
      // $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('button--add-to-cart-label span:not(.text)').hide();
    }

    $('.shopify-payment-button', $product).hide();
    $('.purchase-details__quantity', $product).hide();
    $notifyForm.hide();
    $notifyFormInputs.empty();

    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }

  //Preorder functionality
  var buttonLabelPreorder = window.PXUTheme.translation.preorder;
  var preorderTextMessage = productEl.querySelectorAll('.purchase-details__preorder-text');
  
  if(!variantWithInventory.available) {
    $('[data-add-to-cart-trigger]',$product).find('span.text').text(buttonLabelPreorder);
    if(preorderTextMessage) {
      $(preorderTextMessage).slideDown(200);
    }
  } else {
    if(preorderTextMessage) {
      $(preorderTextMessage).hide();
    }
  }
}

window.selectCallback = selectCallback;
window.PXUTheme.predictiveSearch = {
  vars: {
    term: '',
    searchPath: window.PXUTheme.routes.search_url,
    displayTimer: ''
  },
  init: function () {
    this.unload();
    $('[data-show-search-trigger], [data-autocomplete-true] input').on('click touchstart', function (e) {
      if (!isScreenSizeLarge()) {
        e.stopPropagation();
        const formType = $(this).closest('form').find('[name="type"]').val();
        const position = $(document).scrollTop();
        window.PXUTheme.predictiveSearch.showMobileSearch(formType, position);
      }
    }); // Focus state to display search results

    $('[data-autocomplete-true]').on('focus', function () {
      $(this).parents('[data-autocomplete-true]').find('.search__results-wrapper').show();
    }); // Clicking outside makes the results disappear.

    $(document).on('click focusout', function (e) {
      if (window.PXUTheme.media_queries.large.matches) {
        var searchForm = $(e.target).parents('.search-form');

        if (searchForm.length === 0) {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      }
    }); // Submit wildcard searches

    $("[data-autocomplete-true] form").on("submit", function (e) {
      e.preventDefault();
      const formValue = $(this).find('input[name="q"]').val();
      const cleanFormValue = encodeURI(formValue);
      let searchType = window.PXUTheme.theme_settings.search_option;

      if ($(this).find('[name="type"]').length > 0) {
        searchType = $(this).find('[name="type"]').val();
      }

      if (cleanFormValue == null) {
        window.location.href = window.PXUTheme.routes.search_url + '?type=' + searchType;
      } else {
        window.location.href = window.PXUTheme.predictiveSearch.vars.searchPath + '?type=' + searchType + '&q=' + cleanFormValue + '*';
      }
    });
    $('[data-autocomplete-true] form').each(function () {
      const $this = $(this);
      const input = $this.find('input[name="q"]'); // Adding a list for showing search results.

      const resultWrapper = `
        <div class="search__results-wrapper">
          <h2 class="vertical-search__title">
            ${window.PXUTheme.translation.top_suggestions}
          </h2>
          <ul class="search__results"></ul>
        </div>
      `;
      $(resultWrapper).appendTo($this);
      input.attr('autocomplete', 'off').on('input', function () {
        clearTimeout(window.PXUTheme.predictiveSearch.vars.displayTimer);

        if ($(this).val().length > 3) {
          window.PXUTheme.predictiveSearch.vars.term = $(this).val();
          window.PXUTheme.predictiveSearch.getResults(window.PXUTheme.predictiveSearch.vars.term, $this);
        } else {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      });
    });
  },
  getResults: function (term, $this) {
    let searchType = window.PXUTheme.theme_settings.search_option;

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": searchType,
        "limit": window.PXUTheme.theme_settings.search_to_display,
        "options": {
          "unavailable_products": "last",
          "fields": "title,body,variants.title,variants.sku,vendor,product_type,tag"
        }
      }
    }).done(function (response) {
      const suggestions = [response.resources.results.products, response.resources.results.pages, response.resources.results.articles];
      let filteredResults = []; // Store results in array

      $.each(suggestions, function (index, suggestion) {
        if (suggestion !== undefined && suggestion.length > 0) {
          // Ensure suggestion exists
          filteredResults.push(suggestion);
        }
      }); // Display results

      window.PXUTheme.predictiveSearch.vars.displayTimer = setTimeout(function () {
        window.PXUTheme.predictiveSearch.displayResults(filteredResults[0], $this);
      }, 500);
    });
  },
  displayResults: function (results, $this) {
    const $resultsWrapper = $this.find('.search__results-wrapper');
    const $resultsList = $this.find('.search__results');
    let searchType = window.PXUTheme.theme_settings.search_option;
    $resultsWrapper.show();
    $resultsList.empty();

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    if (results && results.length > 0) {
      $.each(results, function (index, result) {
        let link = $('<a tabindex="0"></a>').attr('href', result.url);

        if (window.PXUTheme.routes.root_url !== '/') {
          link = $('<a tabindex="0"></a>').attr('href', window.PXUTheme.routes.root_url + result.url);
        } // if result is a product


        if (result['price']) {
          function formatPrice(price) {
            return '<span class="money">' + Shopify.formatMoney(price, $('body').data('money-format')) + '</span>';
          }

          let itemPrice;

          if (result.available === true) {
            if (result.compare_at_price_max > result.price_max || result.compare_at_price_min > result.price_min) {
              itemPrice = `${formatPrice(result.price)} <span class="was-price">${formatPrice(result.compare_at_price_max)}</span>`;
            } else {
              if (result.price > 0) {
                if (result.price_min != result.price_max) {
                  itemPrice = `${window.PXUTheme.translation.from} ${formatPrice(result.price)}`;
                } else {
                  itemPrice = `${formatPrice(result.price)}`;
                }
              } else {
                itemPrice = window.PXUTheme.theme_settings.free;
              }
            }
          } else {
            itemPrice = window.PXUTheme.translation.soldOut;
          } // If result has image


          if (result['image']) {
            link.append(`<div class="thumbnail"><img class="lazyload transition--${window.PXUTheme.theme_settings.image_loading_style}" src="${window.PXUTheme.addImageDimension(result['image'], '_300x')}" /></div>`);
          }

          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-pricing price">${itemPrice}</span></div>`); // if result is an article
        } else if (result['summary_html']) {
          if (result.image != 'NULL') {
            link.append(`<div class="thumbnail"><img class="lazyload transition--${window.PXUTheme.theme_settings.image_loading_style}" src="${window.PXUTheme.addImageDimension(result['image'], '_300x')}" /></div>`);
          }

          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-description">'${result.summary_html.replace(/(<([^>]+)>)/ig, "").slice(0, 25)}</span></div>`); // if result is a page
        } else if (result['published_at']) {
          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-description">${result.body.replace(/(<([^>]+)>)/ig, "").slice(0, 25)}</span></div>`);
        } // Wrap link and append to list


        link.wrap('<li class="item-result"></li>');
        $resultsList.append(link.parent());

        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.init();
        }
      });
      $resultsList.prepend(`<li class="all-results"><span class="see-all"><a href="${this.vars.searchPath}?type=${searchType}&q=${this.vars.term}*"> ${window.PXUTheme.translation.all_results} ${window.PXUTheme.icons.right_caret}</a></span></li>`);
      $resultsList.parents('.search__results-wrapper').addClass('results-found');
    } else {
      // if no results
      const noResults = `<li class="item-result"><span class="no-results">${window.PXUTheme.translation.no_results}</span></li>`;
      $resultsList.append(noResults);
      $resultsList.parents('.search__results-wrapper').removeClass('results-found');
    }

    if ($this.parents('.vertical-header__content').length && window.PXUTheme.jsHeader.header_layout === 'vertical') {
      window.PXUTheme.predictiveSearch.alignVerticalSearch();
    }

    $resultsList.show();
  },
  showMobileSearch: function (formType, position) {
    $('body').css('max-height', window.innerHeight);
    $('.mobile-search').fadeIn(200);

    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      $('.mobile-search input[data-q]').focus();
    } else {
      //Set delay to ensure focus triggers on android
      setTimeout(function () {
        $('.mobile-search input[data-q]').focus();
      }, 205);
    }

    document.body.style.position = 'fixed';
    document.body.style.top = '-' + position + 'px';
    $('.mobile-search').css('top', position);
    const searchHeight = window.innerHeight - 46; //Full screen height - form height

    $('.mobile-search .search__results-wrapper').css('max-height', searchHeight);

    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    } else {
      $('.mobile-search [name="type"]').val(window.PXUTheme.theme_settings.search_option);
    }

    $('.search-form .close-search').on('click touchstart', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.PXUTheme.predictiveSearch.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
    });
    $('.search-form .submit-search').on('click touchstart', function (e) {
      $(this).parents('form').submit();
    });
  },
  hideMobileSearch: function (position) {
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position);
    $('.mobile-search').fadeOut(200);
    $('.mobile-search [name="q"]').val('');
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
  },
  alignVerticalSearch: function () {
    const $resultsList = $('.header--vertical .search__results');
    const headerWidth = $('.header--vertical').innerWidth();
    $resultsList.parents('.search__results-wrapper').css({
      'position': 'fixed',
      'left': headerWidth,
      'top': '0'
    });
  },
  unload: function () {
    $('body').off('focus', '[data-autocomplete-true] input');
    $('input[name="q"]').off();
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search__results-wrapper').remove();
  }
};

function isScreenSizeLarge() {
  if (window.PXUTheme.media_queries.large.matches) {
    return true;
  }
}
function isScreenSizeSmall() {
  if (window.PXUTheme.media_queries.medium.matches) {
    return true;
  }
}
window.PXUTheme.scrollToTop = function (element, height) {
  // Check if height argument is present
  if (height != undefined) {
    $('html, body').animate({
      scrollTop: $(element).offset().top - height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 1000);
  }
};

window.PXUTheme.tabs = {
  enableTabs: function () {
    let $tabs = $('.tabs li, .tabs li a');
    $tabs.on('click', function (el) {
      el.preventDefault(); // toggle active tab

      $tabs.removeClass('is-active active');
      $(this).addClass('is-active');
      let $tabIndex = $(this).index();
      let $tabContent = $(this).parents('.tabs').next('.tabs-content'); // toggle corresponding tab content

      $tabContent.children('li, li a').removeClass('is-active active');
      $tabContent.children('li, li a').eq($tabIndex).addClass('is-active').show().css({
        'display': 'block'
      }).siblings().hide().removeClass('is-active');
    });
  },
  unload: function () {
    $('.tabs li, .tabs li a').off();
  }
};

class ProductCard {
  enableSwatches() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.swatch span', ({
        currentTarget
      }) => {
        if ($(currentTarget).data('image').indexOf('no-image') === -1) {
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('src', $(currentTarget).data('image'));
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('srcset', $(currentTarget).data('image'));
        }
      });
    }
  }

  showVariantImage() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.has-secondary-image-swap', ({
        currentTarget
      }) => {
        const $thumbnailImage = $(currentTarget).find('.product-image__wrapper img');
        const $thumbnailVideo = $(currentTarget).find('.product-image__wrapper .video-on-hover');

        if ($thumbnailImage) {
          $thumbnailImage.toggleClass('swap--visible');
        }

        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.enableVideoOnHover($(currentTarget));
        }
      });
      $('body').on('mouseleave', '.has-secondary-image-swap', ({
        currentTarget
      }) => {
        const $thumbnailImage = $(currentTarget).find('.product-image__wrapper img');
        const $thumbnailVideo = $(currentTarget).find('.product-image__wrapper .video-on-hover');

        if ($thumbnailImage) {
          $thumbnailImage.toggleClass('swap--visible');
        }

        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.disableVideoOnHover($(currentTarget));
        }
      });
    }
  }

  showQuickShop() {
    // EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      window.PXUTheme.jsProductClass.load($currentTarget.data('url')).then(({
        html
      }) => {
        $('.js-quick-shop').html(html.content);
        $('.js-quick-shop .js-product_section').addClass('quickshop');

        if (!$('.fancybox-active').length) {
          $.fancybox.open($('.js-quick-shop'), {
            baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            },
            afterShow: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              window.PXUTheme.jsProduct.init($('.js-quick-shop'));
              $quickshop.addClass('quick-shop--loaded');
              $quickshop.addClass('content-loaded');

              if ($('.quickshop .tabs').length > 0) {
                window.PXUTheme.tabs.enableTabs();
              }
            },
            beforeClose: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              $quickshop.removeClass('quick-shop--loaded');
              $quickshop.removeClass('content-loaded');
            }
          });
        }
      }).catch(error => console.error(e));
    });
  }

}

window.PXUTheme.thumbnail = new ProductCard();
const videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
// const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
const videoControls = ``;
let videoPlayers = [];
let videosInRecommendedProductsPlayer;
window.PXUTheme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  setupVideoPlayer: function () {
    const productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    let setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      clickToPlay: false,
      fullscreen: {
        enabled: false,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    let videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function (index, player) {
      player.loop = videoLooping;
      videoPlayers.push(player);
    });
    this.setupListeners();
  },
  setupListeners: function () {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      const id = player.id;
      let $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      } // When a video is playing, pause any other instances


      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          var playerID = player.id || player.media.dataset.plyrVideoId;

          if (instance.id != playerID) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  },
};


function addProductToCart(variantId) {
  var upsellVariantID = variantId;
  var upsellVariantQuantity = 1;
  $.ajax({
    url: window.PXUTheme.routes.cart_add_url,
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {          
      'items': [
        {
          'id': upsellVariantID,
          'quantity': upsellVariantQuantity
        }
      ]
    },
    beforeSend: function () {
    },
    success: function (product) {
      window.PXUTheme.jsCart.updateCart();
      window.PXUTheme.jsCart.toggleCart('show');
    },
    error: function (XMLHttpRequest) {

    }
  });
}

// looks like I don't even need a cookie - could base this completely off the exisitng discount_code cookie which will clear itself
function checkFreeWashbag() {
  if (getCookies("discount_code") == "FREEWASHBAG3267" && getCookies("washbagremoved") != "true") {
    // Use jsCart.cart data if available to avoid duplicate /cart.js call
    const checkAndAddWashbag = (cart) => {
      const isItemInCart = cart.items && cart.items.some(item => item.id === 42339309977788);
      if (!isItemInCart) {
        addProductToCart(42339309977788);
      }
    };

    // Wait for jsCart to have cart data
    const waitForCart = () => {
      if (window.PXUTheme && window.PXUTheme.jsCart && window.PXUTheme.jsCart.cart && window.PXUTheme.jsCart.cart.items) {
        checkAndAddWashbag(window.PXUTheme.jsCart.cart);
      } else {
        setTimeout(() => {
          if (window.PXUTheme && window.PXUTheme.jsCart && window.PXUTheme.jsCart.cart) {
            checkAndAddWashbag(window.PXUTheme.jsCart.cart);
          }
        }, 1000);
      }
    };
    
    setTimeout(waitForCart, 500);
  } 
}

// looks like I don't even need a cookie - could base this completely off the exisitng discount_code cookie which will clear itself
function giftWrapAdded() {
  // Use jsCart.cart data if available to avoid duplicate /cart.js call
  const updateGiftWrapUI = (cart) => {
    const isItemInCart = cart.items && cart.items.some(item => item.id === 43119308767420);
    let wrapCheckboxes = document.querySelectorAll('.wrap_checkbox');
    let wrapUpsellContainer = document.querySelectorAll('.wrap_upsell');
    if (isItemInCart) {
      wrapCheckboxes.forEach(function(checkbox) {
        checkbox.classList.add('checkbox-icon');
      });
      wrapUpsellContainer.forEach(function(container) {
        container.classList.add('hidden');
      });
    } else {
      wrapCheckboxes.forEach(function(checkbox) {
        checkbox.classList.remove('checkbox-icon');
      });
      wrapUpsellContainer.forEach(function(container) {
        container.classList.remove('hidden');
      });
    }
  };

  // Wait for jsCart to have cart data, then use it
  const waitForCart = () => {
    if (window.PXUTheme && window.PXUTheme.jsCart && window.PXUTheme.jsCart.cart && window.PXUTheme.jsCart.cart.items) {
      updateGiftWrapUI(window.PXUTheme.jsCart.cart);
    } else {
      // Retry after jsCart initializes (max 2 seconds)
      setTimeout(() => {
        if (window.PXUTheme && window.PXUTheme.jsCart && window.PXUTheme.jsCart.cart) {
          updateGiftWrapUI(window.PXUTheme.jsCart.cart);
        }
      }, 1000);
    }
  };
  
  setTimeout(waitForCart, 500);
}


function showElementIsScrollable() {
  let productListUpsell = document.querySelectorAll('.main_upsell .ajax-cart__upsell-title');
  let productList = document.querySelectorAll('.ajax-cart__list');
  let wrapUpsell = document.querySelectorAll('.upsells_wrapper');

  productList.forEach(function(list, index) {
  // list.addEventListener('scroll', function () {
  //   console.log('hey');
  //   // console.log(checkInView(list, productListUpsell[index], false));
  //   addEventListener("scrollend", (event) => {});
  // });

  let scrollableHeight = list.scrollHeight - list.clientHeight;

  if (list.scrollTop >= scrollableHeight) {
      wrapUpsell[index].classList.remove('bottom_chevron');
  } else {
    wrapUpsell[index].classList.add('bottom_chevron');
  }

    list.addEventListener('scroll', (e) => {
      let scrollableHeight = list.scrollHeight - list.clientHeight
      if (list.scrollTop >= scrollableHeight) {
          wrapUpsell[index].classList.remove('bottom_chevron');
      } else {
        wrapUpsell[index].classList.add('bottom_chevron');
      }
    })
  });
}







// Update the gift message

function giftMessageUpdate(field) {
  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", window.Shopify.routes.root + "cart/update.js");
  xhttp.setRequestHeader('Content-Type', 'application/json');
  var json = JSON.stringify({
    attributes:{
      "gift-message": field.value
    },
  });
  xhttp.send(json);
}

window.addEventListener('load', (event) => {
  // checkFreeWashbag();
  giftWrapAdded();
  showElementIsScrollable();
});

document.addEventListener('change', function (event) {
  if ( event.target.classList.contains( 'gift-message' ) ) {
    giftMessageUpdate(event.target);
  }
});

document.addEventListener('click', function (event) {
  if ( event.target.classList.contains( 'textarea_toggle' ) ) {
    let giftMessageFields = document.querySelectorAll('.cart__note.field');
    let textareaToggles = document.querySelectorAll('.textarea_toggle');
    giftMessageFields.forEach(function(textarea, index) {
      textarea.classList.toggle('height-0');
      textareaToggles[index].classList.toggle('checkbox-icon')
    });
  }
  if ( event.target.classList.contains( 'wrap_checkbox' ) ) {
    let wrapCheckboxAll = document.querySelectorAll('.wrap_checkbox');
    wrapCheckboxAll.forEach(function(checkbox, index) {
      checkbox.classList.toggle('checkbox-icon');
    });
  }
});

window.PXUTheme.autoDiscounts = {
  init() {
    this.queryParams = new URLSearchParams(document.location.search);
    // if (this.queryParams.get("discount") === "WASHBAG") {
    //   this.addWashbagToCart();
    // }
    let mainContainer = document.querySelector("#DiscountPopups");
    let closeButtons = mainContainer.querySelectorAll("button");
    closeButtons.forEach(button => button.addEventListener("click", function() {
      $.fancybox.close();
    }));
  },
  addWashbagToCart() {
    let $this = this;
    let washbagVariantID = 42339309977788;
    this.checkProductInCart(washbagVariantID).then(productInCart => {
      if (productInCart) {
        $this.updateHistory("WASHBAG");
        return;
      }
      let cartData = {
        "items": [
          {
            "id": washbagVariantID,
            "quantity": 1
          }
        ]
      }
      $.ajax({
        url: window.PXUTheme.routes.cart_add_url,
        dataType: 'json',
        cache: false,
        method: 'post',
        data: cartData,
        beforeSend: function () {},
        success: function (product) {        
          window.PXUTheme.jsCart.updateCart();
          window.PXUTheme.jsCart.toggleCart('show');
  
          $this.updateHistory("WASHBAG");
          $this.openPopup("#DiscountWashbag");
        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          alert(response)
        }
      });
    });
  },
  updateHistory(discountCode) {
    for (const [key, value] of this.queryParams) {
      if (key === 'discount' && value === discountCode) {
        this.queryParams.delete("discount");
      }
    }
    history.replaceState(null, null, `${window.location.pathname}?${this.queryParams.toString()}`)
  },
  openPopup(containerID) {
    let container = document.querySelector(containerID);
    $.fancybox.open(container, {
      baseClass: `${container.id}_popup`,
      animationEffect: false,
      transitionEffect: false,
      animationDuration: 50,
      transitionDuration: 40,
      hash: false,
      infobar : false,
      toolbar: false,
      touch: false,
      clickSlide: false,
      autoFocus: false,
      mobile: {
        preventCaptionOverlap: false,
        toolbar: false,
      },
      onActivate: (instance) => {
        $('html').addClass("no-scroll");
        // console.log(instance);
      },
      afterClose: (instance) => {
        $('html').removeClass("no-scroll");
      }
    });
  },
  checkProductInCart(variantID) {
    return fetch(`${window.PXUTheme.routes.cart_url}.js`)
            .then(response => response.json())
            .then(cartData => {
              for ( let item of cartData.items) {
                if (item.id === variantID) {
                  return true
                } 
              }
              return false;
            })

  }
}


window.PXUTheme.productPageVideos = {
  init() {
    this.playButtonSVG = "<svg xmlns=\"http:\/\/www.w3.org/2000/svg\" viewBox=\"0 0 41 49\" fill=\"none\"><path xmlns=\"http:\/\/www.w3.org\/2000\/svg\" d=\"M39.8838 23.1893C40.857 23.7921 40.857 25.2079 39.8838 25.8107L3.10341 48.5902C2.07637 49.2263 0.750001 48.4876 0.750002 47.2795L0.750004 1.72046C0.750004 0.512405 2.07638 -0.226276 3.10341 0.409807L39.8838 23.1893Z\" fill=\"white\"/></svg>";

    let videos = document.querySelectorAll(".ProductPageVideo");
    this.observerOptions = {
      root: null,
      rootMargin: "0px 0px 2000px 0px",
      threshold: 0,
    };
    videos.forEach( video => this.wrapVideo(video));
  },
  wrapVideo(video) {
    let caption = video.parentNode.querySelector(".ProductPageVideo--caption");
    let wrapper = this.createWrapper(video);
    video.before(wrapper);
    wrapper.appendChild(video);
    if (caption) {
      wrapper.appendChild(caption);
    }
    video.setAttribute("data-processed", true);
    this.createObserverFor(wrapper);
  },
  createWrapper(video) {
    let wrapper = document.createElement("div");
    wrapper.classList.add("ProductPageVideo--wrapper");
    if (video.classList.contains("swiper-slide")) {
      wrapper.classList.add("swiper-slide");
      video.classList.remove("swiper-slide");
    }
    let playButtonContainer = document.createElement("div");
    playButtonContainer.classList.add("ProductPageVideo--wrapper--play_button_container");
    playButtonContainer.innerHTML = this.playButtonSVG;

    let action = video.getAttribute("data-action") || "play";

    playButtonContainer.addEventListener("click", function() {
      if (action === "play") {
        video.controls = true;
        video.muted = false;
        video.play();
        playButtonContainer.remove();
        return;
      }
      if (action == "unmute") {
        if (video.paused) {
          video.play();
        } 
        if (playButtonContainer.getAttribute("playing") !== null) {
          video.muted = true;
        } else {
          video.muted = false;
        }
        playButtonContainer.toggleAttribute("playing");
      }
    });

    wrapper.appendChild(playButtonContainer);
    return wrapper;
  },
  createObserverFor(container) {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let videos = Array.from(container.querySelectorAll("video"));
          for (let video of videos) {
            let sources = Array.from(video.querySelectorAll("source"));
            for (let source of sources) {
              source.src = source.getAttribute('data-src');
              source.removeAttribute("data-src");
            }
            video.load();
          }
          observer.unobserve(container);
        }
      });
    }, this.observerOptions);
    observer.observe(container);
  }
}


window.PXUTheme.setRootParams = {
  init() {
    let header = document.querySelector("#header");
    let mobile_header = document.querySelector("#mobile-header");
    let subHeader = document.querySelector("#SubheaderBar");
    document.documentElement.style.setProperty('--header-height', `${header ? header.clientHeight : 0}px` );
    document.documentElement.style.setProperty('--mobile-header-height', `${mobile_header ? mobile_header.clientHeight : 0}px` );
    document.documentElement.style.setProperty('--subheader-height', `${subHeader ? subHeader.clientHeight : 0}px` );
    this.setTitleHeightForToothbrushProduct();
  },
  setTitleHeightForToothbrushProduct() {
    if (!document.body.classList.contains("product-toothbrush") && !document.body.classList.contains("product-test") && !document.body.classList.contains("product-nogrey") && !document.body.classList.contains("product-presel") && !document.body.classList.contains("product-2-1")) return;
    let title = document.querySelector(".product-block .product_name");
    document.documentElement.style.setProperty('--title-height', `${title ? title.clientHeight + parseInt(document.defaultView.getComputedStyle(title, '').getPropertyValue('margin-bottom')) : 0}px` );
  }
}

window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'submit') {
    fbq('track', 'KlaviyoSignUp');
  }
  console.log(e);
});

function hideKlaviyoPopups() {
    const p = new URLSearchParams(location.search);
    if (p.has('nopopups')) document.cookie = "nopopups=true; path=/";
    if (p.has('nopopups') || document.cookie.includes('nopopups=true')) {
        document.querySelectorAll('[id^="klaviyo-form"]').forEach(f => f.style.display = 'none');
    }
}
document.addEventListener('DOMContentLoaded', hideKlaviyoPopups);

// if (window.location.pathname == "/account/login") {
//   window.location = "/tools/recurring/get-subscription-access"
// }

// const observer = new MutationObserver(mutations => {
//   console.lg
//   let firstElement = document.querySelector(".dys8oc0.vzun380");
//   if (!firstElement) return;  
//   if(!window.matchMedia( "(max-width: 1023px)" ).matches) return;
//   let firstElementContent = firstElement.firstElementChild;

//   let targetLink = document.querySelector("[data-testid='recharge-internal-manage-subscriptions']")?.parentNode;
//   let targetLinkChild = targetLink.firstElementChild.firstElementChild;
  
//   let clonedLink = targetLink.cloneNode("true");
//   clonedLink.classList.add("clone");
  
//   if (targetLinkChild.classList.contains("_1setxj6h0")) {
//     if (firstElementContent.getAttribute("data-testid") == "recharge-internal-manage-subscriptions") {
//       firstElement.remove();
//     }
//   } else {
//     if (firstElementContent.getAttribute("data-testid") != "recharge-internal-manage-subscriptions") {
//       firstElement.before(clonedLink);
//       let a = clonedLink.firstElementChild;
//       a.style.pointerEvents = 'none';
//       setTimeout(()=>{
//         a.style.pointerEvents = "initial"
//       }, 100)
//     }
//   }

// });
// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });

// let buttons = document.querySelectorAll(".rc_form [type='submit']");
// Array.from(buttons).forEach(button=>{
//   if (button.textContent.includes("Get subscription login")) {
//     button.textContent = "Get login link";
//   }
// });

// let links = document.querySelectorAll("#customer_tab_content a");
// Array.from(links).forEach(link=>{
//   console.log(link)
//   if (link.textContent.includes("Return to login")) {
//     link.parentNode.style.display = 'none'
//   }
// });

// let titles = document.querySelectorAll("#customer_tab_content h2");
// Array.from(titles).forEach(title=>{
//   if (title.textContent === "Request account invite") {
//     title.textContent = "Subscription account login";
//   }
// });

// let ps = document.querySelectorAll("#customer_tab_content p");
// Array.from(ps).forEach(p=>{
//   if (p.textContent.includes("Provide your email below in order")) {
//     p.textContent = "Provide your email below, if an account exists we will email you a magic login link. No passwords needed!";
//   } else if (p.textContent.includes("An email will be sent to you")) {
//     p.textContent = "If you have an active subscription you will be sent a link. If you've never subscribed this is done buy purchasing a subscription plan.";
//   } 
// });




window.PXUTheme.queryTests = {
  init() {
    this.params = new URLSearchParams(document.location.search);
    if (this.params.get("applepay") === "true") {
      this.showAdditionalCheckoutOptions();
    }
  },
  showAdditionalCheckoutOptions() {
    let container = document.querySelector(".purchase-details__buttons--additional");
    container.style.display = "block";
  }
}